





















































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'
import AddCustomPOITriggerModal from '@ui/triggers/POI/AddCustomPOITriggerModal'

import DateStep from './DateStep'
import LocationStep from './LocationStep'
import PointsOfInterestStep from './PointsOfInterestStep'
import EventStep from './EventStep'
import AudienceStep from './AudienceStep'
import ActivityTagStep from './ActivityTagStep'
import BrandInfoStep from './BrandInfoStep'
import CreativeStep from './CreativeStep'

settings =
  name: 'CampaignEditWizard'

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId/edit'

    campaignShow:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      fetch: false

    brand:
      resourceName: 'brand'
      slug: 'brand_reps/:brandRepId/brands/:brandInfoId/edit'
      fetch: false

  vue:
    store: ['member']
    mixins: [WizardService.wizard()]

    components: {
      RequestButton,
      AddCustomPOITriggerModal,
      DateStep,
      LocationStep,
      PointsOfInterestStep,
      EventStep,
      AudienceStep,
      ActivityTagStep,
      BrandInfoStep,
      CreativeStep,
    }

    data: ->
      searchTime: null
      slim: false

      wizardModal:
        show: true

    computed:
      isFirstStep: -> @activeStep.idx is 0
      isLastStep: ->
        return true if @org?.id and @nextStep?.name is 'ProfileStep'
        @activeStep.idx + 1 is @steps.length
      nextStep: -> @steps[@activeStep.idx + 1]

      campaignData: -> @prime?.campaign || {}
      brandRepId: -> @$route.query.brandRepId or @member?.brand_rep?.id
      org: -> @campaignData.org
      creatives: -> @campaignData.creatives
      brandData: -> @prime?.brand
      brandInfoId: -> @campaign?.brand_info?.id
      listingClasses: ->
        data = @marketplace?.listing?.classes
        order = @marketplace.listing?.promoted?.classes
        @listingClassOptions = @hashToElementUIOptions data, order
      listingTypes: ->
        data = @marketplace?.listing?.types
        order = @marketplace.listing?.promoted?.types
        @listingTypeOptions = @hashToElementUIOptions data, order
      listingCategories: ->
        data = @marketplace?.listing?.categories
        order = @marketplace.listing?.promoted?.categories
        @listingCategoryOptions = @hashToElementUIOptions data, order
      listingAudiences: ->
        data = @marketplace?.listing?.audiences
        order = @marketplace.listing?.promoted?.audiences
        @listingAudienceOptions = @hashToElementUIOptions data, order

      onSiteSpaceOptions: ->
        booth_10x10: '10 x 10'
        booth_10x20: '10 x 20'
        booth_20x40: '20 x 40'
        booth_40x60: '40 x 60'
        # custom: 'Custom'

      creativeHasSampling: -> !!@creatives?.product_sampling?.length
      creativeHasVideoWall: -> !!@creatives?.video_wall?.length
      creativeHasSocialPost: -> !!@creatives?.social_media_post?.length
      creativeHasPromo: -> !!@creatives?.promo?.length
      creativeHasOnSiteSpace: -> !!@creatives?.onsite_space?.length

    methods:
      hiSave: ->
        @validateActiveStep()
        return unless @stepIsValid()
        @save()
        @hiClose()

      hiClose: ->
        @$router.back()

      save: ->
        if 'brand' is @activeStep.name
          @saveItem('prime.brand', null, skipFlash: true)
        else
          @saveItem('prime.campaign', null, skipFlash: true)

      onSave: ->
        @fetch('campaignShow')

      fetchBrand: -> @fetch('brand')

      searchOnList: (text, list, searchMethod) ->
        return new Promise((resolve, reject) =>
          clearTimeout(@searchTime)
          @searchTime = setTimeout(() =>
            options = {}

            if searchMethod
              resolve(searchMethod())

            for key, value of list
              if "#{value}".toLowerCase().includes("#{text}".toLowerCase())
                options[key] = value

            resolve(options)
          , 300)
        )

      debounce: (cb, time = 300) ->
        clearTimeout(@searchTime)
        @searchTime = setTimeout(cb, time)

      scrollStepToSection: (selector, offset) ->
        @scrollContainerTo('.step', selector, offset)

      generateActivationSnapshot: (type, key) ->
        snapshot = {...@campaignData.activation_prototype }
        snapshot.type = type
        snapshot.key = key
        snapshot

      addCustomPOITrigger: ->
        @$refs.addCustomPOITrigger.fire()
      onCampaignShowAddCustomPoi: ->
        @$refs.addCustomPOITrigger.close()
        @fetch 'campaign'

    watch:
      steps: ->
        { step } = @$route.params
        stepComponent = !!@steps.find((s) -> s.name is step)
        step = 'brand-info' unless stepComponent
        @navToStepName step, { skipSave: true } if step

export default VueOptions.vue settings
